<template>
    <z-page class="dashboard">
        
        <div class="user-item account">
            <div class="title">
                <span class="text">账号信息</span>
            </div>
            <div class="item">
                <span class="name">账号</span>
                <span class="num">{{ $store.getters.userInfo.account }}</span>
            </div>
            <div class="item">
                <span class="name">身份</span>
                <span class="num">{{ $store.getters.userInfo.identityName }}</span>
            </div>
            <img class="icon" src="~@/assets/img/dash-user.svg">
        </div>

        <div class="user-item" v-if='isAdmin'>
            <div class="title">
                <span class="text">账户余额</span>
            </div>
            <div class="balance item">
                <span class="num">{{ data.balance | numbers }}</span>
                <span>元</span>
            </div>
            <img class="icon" src="~@/assets/img/balance.svg">
        </div>

        <div class="user-item" v-if='isAdmin'>
            <div class="title">
                <span class="text">优惠券</span>
                <img class="Notes" src="~@/assets/img/help.svg">
                <div class='tip'>新优惠卷的使用与会员等级挂钩，要使用<br/>新优惠卷必须是银卡会员或金卡会员</div>
                <span class='_text'>{{data.memberGrade |Level}}</span>
            </div>
            <div class="item">
                <span class="name">新优惠券</span>
                <span class="num">{{ data.newCouponsBalance | numbers }}</span>
                <span>元</span>
            </div>
            <div class="item">
                <span class="name">老优惠券</span>
                <span class="num">{{ data.couponsBalance | numbers }}</span>
                <span>元</span>
            </div>
            <img class="icon" src="~@/assets/img/coupon.svg">
        </div>

    </z-page>
</template>

<script>
    export default {
        data(){
            return {
                data:{},
            }
        },

        computed:{
            isAdmin(){
                return this.$store.getters.userInfo.isAdmin;
            }
        },

        filters:{
            numbers(str){
                let num = parseFloat(str);
                return isNaN(num)?'--':num.toFixed(2);
            },
        },

        created(){
            this.getData();
        },



        methods:{
            getData(){
                let url = `/api/supplier/user/dashboard/show`;
                this.$http.get(url)
                .then(res=>{
                    if(res.code == 200){
                        this.data = res.res_data;
                        console.log(this.data);
                        
                    }
                })
            },
        }
    }
</script>

<style lang='less' scoped>
    .dashboard{
        background:transparent;
        padding: 16px;
        .clear();
        .user-item{
            background: #fff;
            width:240px;
            min-height: 114px;
            box-shadow:0px 4px 6px 0px rgba(0,0,0,0.2);
            border-radius:2px;
            padding: 12px;
            float: left;
            margin-right: 16px;
            position: relative;
            &:last-child{
                margin-right: 0;
            }

            .title{
                position: relative;
                .tip{
                        pointer-events: none;
                        position: absolute;
                        background: rgba(0, 0, 0, 0.7);
                        opacity: 0;
                        z-index:3;
                        transition: 0.3s;
                        top:100%;
                        right:0%;
                        color:#fff;
                        white-space: nowrap;
                        padding: 0 8px;
                        line-height: 28px;
                        border-radius:4px;
                    }
                .text{
                    display:inline-block;
                    font-size: 14px;
                    font-weight: 600;
                    box-sizing: border-box;
                    vertical-align: middle;
                }
                .Notes{
                    margin-left:9px;
                    display:inline-block;
                    width:14px;
                    box-sizing: border-box;
                    vertical-align: middle;
                    &:hover{
                        cursor: pointer;
                        opacity: 1;
                        &+.tip{
                            opacity: 1;
                        }
                    }
                    
                }
                ._text{
                    font-size:12px;
                    font-family:'PingFang-SC-Regular';
                    color:rgba(16,30,56,0.6);
                    float:right;
                    box-sizing: border-box;
                    vertical-align: middle;
                }
            }

            .item{
                font-size: 12px;
                line-height: 28px;
                margin-top: 4px;
       
                .name{
                    display: inline-block;
                    margin-right: 10px;
                }
                .num{
                    color:@g_blue;
                    display: inline-block;
                    margin-right: 3px;
                    font-size: 20px;
                    font-weight: 500;
                }
            }

            .balance{
                position: relative;
                top:25px;
                .num{
                    font-size: 36px;
                }
            }

            // 图标
            .icon{
                position: absolute;
                z-index: 0;
                right: 12px;
                bottom: 12px;
            }

        }

        .account{
            .num{
                font-size: 14px !important; 
            }
        }
    }
</style>
